import { RequestedLessonListDTO } from "../../../../admin/models/requested-lesson-list.model";
import { GetAllTeacherDocumentsDTO } from "../../../../shared/services/user/user.model";

export const ADMIN_FEATURE_KEY = 'ADMINM';

export interface State{
    loaded:boolean;
    error?:string | null;
    data: GetAllTeacherDocumentsDTO[] |null|number|RequestedLessonListDTO[];
}